import { createAction } from '@reduxjs/toolkit';
import { shareSlice } from './reducer';

export const { receiveTagsData, enableFetching, receiveTags } = shareSlice.actions;

export const fetchTagsData = createAction('share/fetchTagsData');
